import React, { useRef } from 'react'
import clockBig from '../../Resources/clockBig.gif'
import { Icon } from './Icon'
import { Text } from './Text'
import { motion } from 'framer-motion'
import { COLORS } from './designSystem'

const clickButtonVariants = (e) => ({
  idle: { x: 0, y: 0, scale: 1 },
  expanded: { scale: 1, x: 0, y: 0, width: e }
})

const clickButtonNoShadowVariants = (e) => ({
  idle: { x: 0, y: 0, scale: 1 },
  expanded: { scale: 1, x: 0, y: 0, width: e }
})

const ImgSpinner = () =>
  <img alt='loading' src={clockBig} style={{ maxWidth: 50, maxHeight: 30, marginLeft: 10 }} />

export const Button = ({ round, iconSize, disabled, hidden, spinner, icon, label, onClick, style, iconStyle, width, tooltip, iconInverted, inverted, labelProps = {}, noShadow, styleText, primary, secondary }) => {
  const tooltipRef = useRef(null)

  if (hidden) return null
  if (spinner) return <ImgSpinner />

  const buttonStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLORS.primary,
    border: `1px solid ${COLORS.primaryDark}`,
    borderRadius: 7,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    userSelect: 'none',
    width: width || 'auto',
    overflow: 'hidden',
    height: '40px',
    padding: '10px 15px',
    transition: 'box-shadow 0.15s ease',
    ...(round ? { width: 30, height: 30, borderRadius: 15 } : {}),
    ...(secondary ? { backgroundColor: '#f5f5f5', color: COLORS.primary, border: `1.5px solid ${COLORS.primary}` } : {}),
    ...(inverted ? { backgroundColor: '#32324e', border: '1px solid #32324e' } : {}),
    ...(tooltip ? { color: '#f5f5f5' } : {}),
    ...style
  }

  const iconDefaultStyle = {
    marginTop: -1,
    marginLeft: 6.5
  }

  const expansion = tooltipRef.current?.offsetWidth ? tooltipRef.current?.offsetWidth + 30 : 'auto'
  const variants = noShadow ? clickButtonNoShadowVariants : clickButtonVariants

  const doNothing = () => null

  const onClickFunction = (e) => {
    // Evita il doppio click
    if (e?.detail !== 1) doNothing()
    else onClick(e)
  }

  return (
    <motion.div
      whileHover={
        round && tooltip
          ? 'expanded'
          : !disabled
            ? {
                boxShadow: secondary
                  ? '0 2px 8px rgba(0, 0, 0, 0.12)'
                  : '0 2px 10px rgba(0, 70, 128, 0.4)',
                scale: 1.02
              }
            : undefined
      }
      whileTap={!disabled ? { scale: 0.97 } : undefined}
      onClick={!disabled ? onClickFunction : undefined}
      animate='idle'
      transition={{ delay: 0.3, duration: 0.5 }}
      style={buttonStyle}
      variants={variants(expansion)}
    >
      {icon ? <Icon name={icon} size={iconSize || 18} style={{ ...iconDefaultStyle, ...iconStyle }} color={(inverted || iconInverted || secondary) ? COLORS.primary : '#ffffff'} /> : null}
      {label && !round ? (<Text color={secondary ? COLORS.primary : '#f5f5f5'} bold center value={label} style={{ marginLeft: icon && 15, flexGrow: width ? 1 : 0, textAlign: 'center', ...styleText, width: '100%' }} />) : null}
      {<div ref={tooltipRef}><Text style={{ whiteSpace: 'nowrap', display: 'block' }} bold value={tooltip} color={inverted ? 'white' : '#f5f5f5'} {...labelProps} /></div>}
    </motion.div>
  )
}
